import { tegBrand } from './teg'
import type { BrandConfig } from './types'

export const brand: BrandConfig = tegBrand

export const companyName = brand.name
export const companyNameUpper = brand.nameUpper

export const pageTitle = (page: string) => `${page} - ${brand.nameUpper}`

export const applyBrandDocumentMeta = () => {
    document.title = brand.seo.defaultTitle

    const themeColor = document.querySelector('meta[name="theme-color"]')
    if (themeColor) {
        themeColor.setAttribute('content', brand.seo.themeColor)
    }

    const setIcon = (rel: string, href: string, sizes?: string, type?: string) => {
        const selector = sizes ? `link[rel="${rel}"][sizes="${sizes}"]` : `link[rel="${rel}"]`
        let link = document.querySelector<HTMLLinkElement>(selector)
        if (!link) {
            link = document.createElement('link')
            link.rel = rel
            document.head.appendChild(link)
        }
        link.href = href
        if (sizes) link.sizes.add(sizes)
        if (type) link.type = type
    }

    const { favicons } = brand
    setIcon('icon', favicons.icon32, '32x32', 'image/webp')
    setIcon('icon', favicons.icon192, '192x192', 'image/webp')
    setIcon('apple-touch-icon', favicons.apple180, '180x180')
    setIcon('apple-touch-icon', favicons.apple270, '270x270')
}

export type { BrandConfig, BrandFavicons, BrandLogo } from './types'
